import VaccinationProgressBarBlock from './VaccinationProgressBarBlock';

export default VaccinationProgressBarBlock;
